"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Icon = _interopRequireDefault(require("@airasia/phoenix-components/components/Icon"));

var _Spinner = _interopRequireDefault(require("@airasia/phoenix-components/components/Spinner"));

var _Theme = _interopRequireDefault(require("@airasia/phoenix-components/components/Theme"));

var _constant = require("../../constant");

var _utilities = _interopRequireDefault(require("../../../utilities"));

var _BottomSheet = _interopRequireDefault(require("@airasia/phoenix-components/components/BottomSheet"));

var _utils = require("../../FlightSearchWidget/utils");

var _cryptoJs = _interopRequireDefault(require("crypto-js"));

var _constant2 = require("../constant");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}
/* eslint-disable react-hooks/exhaustive-deps */

/* eslint-disable react/prop-types */


var SsoWidgetCssTweak = (0, _styledComponents.css)(["#airasia_widget .aaw-container,.airasia-widget-style .aaw-container{width:100%;max-width:unset;outline:none;}#airasia_widget .aaw-main-container--new-horizontal,.airasia-widget-style .aaw-main-container--new-horizontal{max-width:none;}"]);

var SsoModalWrapper = _styledComponents.default.div.withConfig({
  displayName: "SSOWidgetHandler__SsoModalWrapper",
  componentId: "sc-nhbj10-0"
})(["z-index:10000;position:fixed;width:700px;margin:0 auto;outline:none;overflow:auto;background-color:", ";top:50%;transform:translateY(-50%);left:0;right:0;pointer-events:auto;border:1px solid rgba(34,34,34,0.2);border-radius:", ";outline:0;padding:0 ", ";display:flex;justify-content:center;align-items:center;flex-direction:column;min-height:90px;", ""], function (props) {
  return props.theme.colors.default;
}, function (props) {
  return props.theme.borderRadius.medium;
}, function (props) {
  return props.theme.space.small;
}, SsoWidgetCssTweak);

var WidgetOverlay = _styledComponents.default.div.withConfig({
  displayName: "SSOWidgetHandler__WidgetOverlay",
  componentId: "sc-nhbj10-1"
})(["position:fixed;top:0;bottom:0;left:0;right:0;background-color:", ";transition:ease-out 0.3s;z-index:9999;opacity:0.7;"], function (_ref) {
  var theme = _ref.theme;
  return theme.backgroundColor.black;
});

var SpinnerWrapper = _styledComponents.default.div.withConfig({
  displayName: "SSOWidgetHandler__SpinnerWrapper",
  componentId: "sc-nhbj10-2"
})(["top:50%;transform:translateY(-50%);position:relative;display:flex;justify-content:center;"]);

var LoginModalClose = function LoginModalClose() {
  var evt = new CustomEvent('loginModalClose', {
    detail: true
  });
  window.dispatchEvent(evt);
};

var CloseButton = (0, _styledComponents.default)(function (_ref2) {
  var handleClick = _ref2.handleClick,
      icon = _ref2.icon,
      tabIndex = _ref2.tabIndex,
      iconColor = _ref2.iconColor,
      className = _ref2.className;
  return /*#__PURE__*/_react.default.createElement("div", {
    id: "airasia-sso-modal-wrapper-close-button",
    className: className,
    role: "button",
    tabIndex: tabIndex,
    onClick: function onClick() {
      LoginModalClose();
      handleClick(false);
    },
    onKeyDown: function onKeyDown(e) {
      LoginModalClose();

      _utilities.default.keyDownHandler(e, function () {
        return handleClick(false);
      }, _constant.KEY_CODE.ENTER);
    }
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    icon: icon,
    fontsize: _constant2.DEFAULT_CONFIG.TITLE_NORMAL,
    color: iconColor,
    accessible: false
  }));
}).withConfig({
  displayName: "SSOWidgetHandler__CloseButton",
  componentId: "sc-nhbj10-3"
})(["cursor:pointer;height:24px;width:24px;float:right;padding:10px;"]);
var SsoContainer = (0, _styledComponents.default)(function (_ref3) {
  var handleClick = _ref3.handleClick,
      className = _ref3.className,
      showSpinner = _ref3.showSpinner,
      isLoginMandated = _ref3.isLoginMandated;
  return /*#__PURE__*/_react.default.createElement("div", {
    id: "sso-container",
    className: className
  }, !showSpinner && !isLoginMandated && /*#__PURE__*/_react.default.createElement(CloseButton, {
    icon: "CloseIcon",
    tabIndex: "0",
    handleClick: handleClick
  }), /*#__PURE__*/_react.default.createElement("div", {
    id: "airasia_widget",
    style: {
      display: 'block',
      fontFamily: 'DM Sans'
    }
  }));
}).withConfig({
  displayName: "SSOWidgetHandler__SsoContainer",
  componentId: "sc-nhbj10-4"
})(["@media screen and (min-width:", "){width:100%;}@media screen and (max-width:", "){padding:0px 16px 10px;margin-bottom:60px;}@media screen and (max-width:", "){padding:0px 0px 48px;margin-bottom:60px;}"], _constant.BREAKPOINTS.DESKTOP, _constant.BREAKPOINTS.MOBILE, _constant.BREAKPOINTS.SMALL_MOBILE);

var SSOWidgetHandler = function SSOWidgetHandler(props) {
  var handleClick = props.handleClick,
      setLoginInfo = props.setLoginInfo,
      loginclicked = props.loginclicked,
      isMobile = props.isMobile,
      loginStatus = props.loginStatus,
      doPolling = props.doPolling,
      shouldSetCookie = props.shouldSetCookie,
      setDuplicateCookieAATokens = props.setDuplicateCookieAATokens,
      environment = props.environment,
      loginLabel = props.loginLabel,
      setLoginStatusCallback = props.setLoginStatusCallback,
      setBigPoints = props.setBigPoints,
      setUserInfoCallback = props.setUserInfoCallback,
      deviceType = props.deviceType,
      reloadOnLogin = props.reloadOnLogin,
      locale = props.locale,
      currency = props.currency,
      enableBigPoints = props.enableBigPoints,
      enableFavoriteMembers = props.enableFavoriteMembers,
      getBaseDomain = props.getBaseDomain,
      showBigLoyaltyPoints = props.showBigLoyaltyPoints,
      setCreditBalance = props.setCreditBalance,
      enableCreditBalance = props.enableCreditBalance,
      showCreditBalance = props.showCreditBalance,
      _props$theme = props.theme,
      theme = _props$theme === void 0 ? 'AIRASIA_CLASSIC' : _props$theme,
      secretKey = props.secretKey,
      _props$isLoginMandate = props.isLoginMandated,
      isLoginMandated = _props$isLoginMandate === void 0 ? false : _props$isLoginMandate,
      getInfoConfigTokens = props.getInfoConfigTokens,
      callCreditEndpointV2 = props.callCreditEndpointV2;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var configuration = {
    elementRoot: 'airasia_widget',
    hideSignupTab: false,
    lang: 'en',
    orientation: 'horizontal'
  };

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      scriptLoaded = _useState2[0],
      setScriptLoaded = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      styleLoaded = _useState4[0],
      setStyleLoaded = _useState4[1];

  var _useState5 = (0, _react.useState)(true),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      showSpinner = _useState6[0],
      setShowSpinner = _useState6[1];

  var ssoModalRef = (0, _react.useRef)(null);
  var userData;

  function AddMinutesToDate(date, minutes) {
    return new Date(date.getTime() + minutes * 60000);
  }

  var now = new Date();
  var expTime = AddMinutesToDate(now, _constant2.EXP_TIME_IN_MINUTES).getTime();

  var createTags = function createTags(tagName, srcKey, srcValue, typeKey, typeValue) {
    var callback = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

    if (typeof window !== 'undefined') {
      var s = document.createElement(tagName);
      s.setAttribute(srcKey, srcValue);
      s.setAttribute(typeKey, typeValue); // eslint-disable-next-line no-unused-expressions

      tagName === 'link' ? document.head.appendChild(s) : document.body.appendChild(s);

      if (tagName !== 'link') {
        s.setAttribute('async', '');

        s.onload = function () {
          setScriptLoaded(true);
          if (callback) callback();
        };
      } else {
        s.onload = function () {
          setStyleLoaded(true);
          if (callback) callback();
        };
      }
    }
  };

  var dispatchEventHandler = function dispatchEventHandler(eventName, value) {
    var evt = new CustomEvent(eventName, {
      detail: value
    });
    window.dispatchEvent(evt);
  };

  var setCookie = function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=".concat(d.toUTCString());
    document.cookie = "".concat(cname, "=").concat(cvalue, ";").concat(expires, ";path=/;domain=").concat(getBaseDomain());
  };

  var deleteCookie = function deleteCookie() {
    localStorage.removeItem('bp');
    document.cookie = "aa_tokens=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=".concat(getBaseDomain(), ";");
  };

  var encode = function encode(sessionData) {
    return _cryptoJs.default.AES.encrypt(JSON.stringify(sessionData), secretKey);
  };

  var decode = function decode(sessionData) {
    return JSON.parse(_cryptoJs.default.enc.Utf8.stringify(_cryptoJs.default.AES.decrypt(sessionStorage.getItem(sessionData), secretKey)));
  };

  var createSessionData = function createSessionData(expT, p1, v1, p2, v2) {
    var _ref4;

    return _ref4 = {
      expTime: expT
    }, (0, _defineProperty2.default)(_ref4, p1, v1), (0, _defineProperty2.default)(_ref4, p2, v2), _ref4;
  };

  var createSessionStorage = function createSessionStorage(keyName, eTime, prop1, val1, prop2, val2) {
    if (secretKey) sessionStorage.setItem(keyName, encode(createSessionData(eTime, prop1, val1, prop2, val2)));
  };

  var callSSO = function callSSO(fn) {
    return window.aaWidget[fn]();
  };

  var checkSessionData = function checkSessionData(key) {
    return secretKey && sessionStorage.getItem(key) && decode(key).expTime > new Date().getTime();
  };

  function successCallback(_x) {
    return _successCallback.apply(this, arguments);
  }

  function _successCallback() {
    _successCallback = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(data) {
      var cookieName, cookieExpiryInDays;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (shouldSetCookie) {
                setCookie('aa_tokens', encodeURIComponent(JSON.stringify(data)), 180);
              }

              if (setDuplicateCookieAATokens) {
                cookieName = setDuplicateCookieAATokens.cookieName, cookieExpiryInDays = setDuplicateCookieAATokens.cookieExpiryInDays;
                setCookie(cookieName, encodeURIComponent(JSON.stringify(data)), cookieExpiryInDays);
              }

              handleClick();

              if (reloadOnLogin) {
                window.location.reload();
              } else {
                if (typeof window.aaWidget !== 'undefined' && !reloadOnLogin) {
                  callSSO(_constant2.SESSION_KEYS.GETUSER).then(function (res) {
                    createSessionStorage(_constant2.SESSION_KEYS.USERDATA, expTime, _constant2.SESSION_KEYS.RESPONSE, res);
                    createSessionStorage(_constant2.SESSION_KEYS.ISLOGGEDIN, expTime, _constant2.SESSION_KEYS.ISLOGGEDIN, true);
                    dispatchEventHandler('getLoggedInUserData', userData);
                    specialAccessHandler({
                      userInfo: res
                    });
                    setLoginInfo(res.firstName);
                    setUserInfoCallback({
                      bigmemberId: res.loyaltyId,
                      loyaltyTier: res.loyaltyTier
                    });
                  });
                }

                setLoginStatusCallback(true);
              }

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _successCallback.apply(this, arguments);
  }

  var failureFunction = function failureFunction() {
    // console.error('failureInitialization: ', error);
    setLoginStatusCallback(false);

    if (shouldSetCookie) {
      deleteCookie();
    }

    if (getInfoConfigTokens) {
      getInfoConfigTokens(null);
    }
  };

  var initializeAAWidget = function initializeAAWidget(successCallbackHandler) {
    if (typeof window.aaWidget !== 'undefined') {
      window.aaWidget.initialize({
        elementRoot: configuration.elementRoot,
        hideSignupTab: configuration.hideSignupTab,
        successCallback: successCallbackHandler,
        failureCallback: failureFunction,
        orientation: configuration.orientation
      });
    }
  };

  var reloadWidget = function reloadWidget() {
    if (typeof window !== 'undefined') {
      var d = document.getElementById('airasia_widget');

      if (d) {
        d.innerHTML = '';
      }

      initializeAAWidget(successCallback);
    }
  };

  (0, _react.useEffect)(function () {
    var scriptWithLocale = _constant2.ENV[environment].script.replace('{locale}', locale);

    createTags('script', 'src', "".concat(scriptWithLocale), 'type', 'text/javascript');
  }, [locale]);

  var resetLoginLabel = function resetLoginLabel() {
    setLoginInfo(loginLabel);
    setUserInfoCallback({
      bigmemberId: null,
      loyaltyTier: null
    });
  };

  function getUserData() {
    return _getUserData.apply(this, arguments);
  }

  function _getUserData() {
    _getUserData = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;

              if (!checkSessionData(_constant2.SESSION_KEYS.USERDATA)) {
                _context2.next = 5;
                break;
              }

              userData = decode(_constant2.SESSION_KEYS.USERDATA).response;
              _context2.next = 9;
              break;

            case 5:
              _context2.next = 7;
              return callSSO(_constant2.SESSION_KEYS.GETUSER);

            case 7:
              userData = _context2.sent;
              createSessionStorage(_constant2.SESSION_KEYS.USERDATA, expTime, _constant2.SESSION_KEYS.RESPONSE, userData);

            case 9:
              specialAccessHandler({
                userInfo: userData
              });

              if (!userData.firstName) {
                _context2.next = 15;
                break;
              }

              dispatchEventHandler('getLoggedInUserData', userData);
              setLoginInfo(userData.firstName);
              setUserInfoCallback({
                bigmemberId: userData.loyaltyId,
                loyaltyTier: userData.loyaltyTier
              });
              return _context2.abrupt("return", true);

            case 15:
              resetLoginLabel();
              return _context2.abrupt("return", false);

            case 19:
              _context2.prev = 19;
              _context2.t0 = _context2["catch"](0);
              resetLoginLabel();
              return _context2.abrupt("return", false);

            case 23:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 19]]);
    }));
    return _getUserData.apply(this, arguments);
  }

  var makeApiCall = function makeApiCall(url, headers) {
    if (typeof fetch !== 'function') {
      return;
    } // eslint-disable-next-line consistent-return


    return new Promise(function (resolve, reject) {
      fetch(url, {
        method: 'GET',
        headers: headers
      }).then(function (response) {
        if (response.status === 200) {
          return response.json();
        }

        return reject(response);
      }).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  };

  function getPoints(_x2) {
    return _getPoints.apply(this, arguments);
  }

  function _getPoints() {
    _getPoints = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(_ref5) {
      var userConfig, tokens, apiKey, id, accessToken, userId, headerValue, result;
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              userConfig = _ref5.userConfig, tokens = _ref5.tokens;

              if (!enableBigPoints) {
                _context3.next = 17;
                break;
              }

              apiKey = userConfig.apiKey, id = userConfig.id;
              accessToken = tokens.accessToken, userId = tokens.userId;
              headerValue = {
                'user-id': userId,
                'x-aa-client-id': id,
                authorization: accessToken,
                'x-api-key': apiKey,
                origin: window.location.origin
              };
              _context3.prev = 5;
              _context3.next = 8;
              return makeApiCall(_constant2.ENV[environment].bigPoints, headerValue);

            case 8:
              result = _context3.sent;
              setBigPoints(result.bigPointsBalance);
              dispatchEventHandler('getBigPoints', result.bigPointsBalance); // localStorage.setItem('bp', result.bigPointsBalance);

              _context3.next = 17;
              break;

            case 13:
              _context3.prev = 13;
              _context3.t0 = _context3["catch"](5);
              showBigLoyaltyPoints(false);
              dispatchEventHandler('getBigPoints', 'error');
            // console.error('loyalty points failed', e);

            case 17:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[5, 13]]);
    }));
    return _getPoints.apply(this, arguments);
  }

  function jwtCall() {
    return _jwtCall.apply(this, arguments);
  }

  function _jwtCall() {
    _jwtCall = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
      var authHeader, body, response;
      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              authHeader = {
                'Content-Type': 'application/json'
              };
              body = {
                username: _constant2.AUTH[environment].username,
                password: _constant2.AUTH[environment].password
              };
              _context4.prev = 2;
              _context4.next = 5;
              return _utilities.default.post(_constant2.ENV[environment].jwtAuth, authHeader, body);

            case 5:
              response = _context4.sent;
              _context4.next = 10;
              break;

            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4["catch"](2);

            case 10:
              return _context4.abrupt("return", response);

            case 11:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[2, 8]]);
    }));
    return _jwtCall.apply(this, arguments);
  }

  function callCreditEndpoint(_x3, _x4, _x5) {
    return _callCreditEndpoint.apply(this, arguments);
  }

  function _callCreditEndpoint() {
    _callCreditEndpoint = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(creditHeader, navitaireCustomerNumber, tokens) {
      var result, creditBalance;
      return _regenerator.default.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;

              if (!callCreditEndpointV2) {
                _context5.next = 7;
                break;
              }

              _context5.next = 4;
              return _utilities.default.post(_constant2.ENV[environment].creditBalanceV2.replace('{currency}', currency), creditHeader, tokens);

            case 4:
              result = _context5.sent;
              _context5.next = 10;
              break;

            case 7:
              _context5.next = 9;
              return makeApiCall(_constant2.ENV[environment].creditBalance.replace('{customerNumber}', navitaireCustomerNumber).replace('{currency}', currency), creditHeader);

            case 9:
              result = _context5.sent;

            case 10:
              creditBalance = parseFloat(result.creditBalance).toFixed(2);
              setCreditBalance("".concat(creditBalance, " ").concat(result.currencyCode));
              _context5.next = 17;
              break;

            case 14:
              _context5.prev = 14;
              _context5.t0 = _context5["catch"](0);
              showCreditBalance(false);
            // console.error('credit balance failed', e);

            case 17:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[0, 14]]);
    }));
    return _callCreditEndpoint.apply(this, arguments);
  }

  function getCreditBalance(_x6) {
    return _getCreditBalance.apply(this, arguments);
  }

  function _getCreditBalance() {
    _getCreditBalance = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(_ref6) {
      var userInfo, tokens, navitaireCustomerNumber, creditHeader, jwtCookie, jwtToken;
      return _regenerator.default.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              userInfo = _ref6.userInfo, tokens = _ref6.tokens;

              if (enableCreditBalance) {
                navitaireCustomerNumber = userInfo.navitaireCustomerNumber;
                creditHeader = {
                  'Content-Type': 'application/json',
                  Authorization: 'Bearer '
                };
                jwtCookie = (0, _utils.getCookie)('cosmos_token');

                if (jwtCookie && jwtCookie != null) {
                  jwtToken = JSON.parse(decodeURIComponent(jwtCookie)).jwt;

                  if (jwtToken && jwtToken != null) {
                    creditHeader.Authorization += jwtToken;
                    callCreditEndpoint(creditHeader, navitaireCustomerNumber, tokens);
                  } else {
                    showCreditBalance(false);
                  }
                } else {
                  jwtCall().then(function (result) {
                    if (result.jwt !== undefined) {
                      jwtToken = result.jwt;
                      creditHeader.Authorization += jwtToken;
                      callCreditEndpoint(creditHeader, navitaireCustomerNumber, tokens);
                      setCookie('cosmos_token', encodeURIComponent(JSON.stringify({
                        jwt: jwtToken
                      })), 0.00972222);
                    } else {
                      showCreditBalance(false);
                    }
                  }).catch(function () {
                    showCreditBalance(false); // console.error('getting jwt failed', error);

                    return null;
                  });
                }
              }

            case 2:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));
    return _getCreditBalance.apply(this, arguments);
  }

  function getFavoriteMembers(_x7) {
    return _getFavoriteMembers.apply(this, arguments);
  }

  function _getFavoriteMembers() {
    _getFavoriteMembers = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7(_ref7) {
      var userConfig, tokens, apiKey, id, accessToken, userId, headerValue, result;
      return _regenerator.default.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              userConfig = _ref7.userConfig, tokens = _ref7.tokens;

              if (!enableFavoriteMembers) {
                _context7.next = 15;
                break;
              }

              apiKey = userConfig.apiKey, id = userConfig.id;
              accessToken = tokens.accessToken, userId = tokens.userId;
              headerValue = {
                'user-id': userId,
                'x-aa-client-id': id,
                authorization: accessToken,
                'x-api-key': apiKey,
                origin: window.location.origin
              };
              _context7.prev = 5;
              _context7.next = 8;
              return makeApiCall(_constant2.ENV[environment].favoriteMembers.replace('{userId}', userId), headerValue);

            case 8:
              result = _context7.sent;
              dispatchEventHandler('getFavoriteMembers', {
                user: userData,
                favoriteMembers: result.favoriteMembers
              });
              _context7.next = 15;
              break;

            case 12:
              _context7.prev = 12;
              _context7.t0 = _context7["catch"](5);
              dispatchEventHandler('getFavoriteMembers', 'error');
            // console.error('Favorite Members failed', e);

            case 15:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, null, [[5, 12]]);
    }));
    return _getFavoriteMembers.apply(this, arguments);
  }

  function specialAccessHandler(_x8) {
    return _specialAccessHandler.apply(this, arguments);
  }

  function _specialAccessHandler() {
    _specialAccessHandler = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8(_ref8) {
      var userInfo, userConfig, tokens;
      return _regenerator.default.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              userInfo = _ref8.userInfo;

              if (!checkSessionData(_constant2.SESSION_KEYS.USERCONFIGTOKENS)) {
                _context8.next = 6;
                break;
              }

              userConfig = decode(_constant2.SESSION_KEYS.USERCONFIGTOKENS).userConfig;
              tokens = decode(_constant2.SESSION_KEYS.USERCONFIGTOKENS).tokens;
              _context8.next = 13;
              break;

            case 6:
              _context8.next = 8;
              return callSSO(_constant2.SESSION_KEYS.GETCONFIG);

            case 8:
              userConfig = _context8.sent;
              _context8.next = 11;
              return callSSO(_constant2.SESSION_KEYS.GETTOKENS);

            case 11:
              tokens = _context8.sent;
              createSessionStorage(_constant2.SESSION_KEYS.USERCONFIGTOKENS, expTime, _constant2.SESSION_KEYS.CONFIG, userConfig, _constant2.SESSION_KEYS.TOKENS, tokens);

            case 13:
              if (shouldSetCookie) {
                if (tokens && userConfig) {
                  setCookie('aa_tokens', encodeURIComponent(JSON.stringify(tokens)), 180);

                  if (userConfig && userConfig.apiKey) {
                    sessionStorage.setItem('apiKey', JSON.stringify(userConfig.apiKey));
                  }

                  if (userConfig && userConfig.id) {
                    sessionStorage.setItem('clientId', JSON.stringify(userConfig.id));
                  }
                } else {
                  deleteCookie();
                }
              }

              getPoints({
                userConfig: userConfig,
                tokens: tokens,
                userInfo: userInfo
              });
              getCreditBalance({
                userInfo: userInfo,
                tokens: tokens
              });
              getFavoriteMembers({
                userConfig: userConfig,
                tokens: tokens
              });

              if (getInfoConfigTokens) {
                getInfoConfigTokens({
                  userInfo: userInfo,
                  userConfig: userConfig,
                  tokens: tokens
                });
              }

            case 18:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));
    return _specialAccessHandler.apply(this, arguments);
  }

  function checkUserIsLogged() {
    return _checkUserIsLogged.apply(this, arguments);
  }

  function _checkUserIsLogged() {
    _checkUserIsLogged = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee9() {
      var a, p;
      return _regenerator.default.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.prev = 0;

              if (!checkSessionData(_constant2.SESSION_KEYS.ISLOGGEDIN)) {
                _context9.next = 5;
                break;
              }

              a = decode(_constant2.SESSION_KEYS.ISLOGGEDIN).isLoggedIn;
              _context9.next = 9;
              break;

            case 5:
              _context9.next = 7;
              return callSSO(_constant2.SESSION_KEYS.ISLOGGEDIN);

            case 7:
              a = _context9.sent;
              createSessionStorage(_constant2.SESSION_KEYS.ISLOGGEDIN, expTime, _constant2.SESSION_KEYS.ISLOGGEDIN, a);

            case 9:
              if (!a) {
                _context9.next = 14;
                break;
              }

              _context9.next = 12;
              return getUserData();

            case 12:
              p = _context9.sent;
              return _context9.abrupt("return", p);

            case 14:
              resetLoginLabel();
              return _context9.abrupt("return", a);

            case 18:
              _context9.prev = 18;
              _context9.t0 = _context9["catch"](0);
              resetLoginLabel();
              return _context9.abrupt("return", false);

            case 22:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, null, [[0, 18]]);
    }));
    return _checkUserIsLogged.apply(this, arguments);
  }

  var handleUserLoggedInAsync = function handleUserLoggedInAsync() {
    try {
      checkUserIsLogged().then(function (res) {
        setLoginStatusCallback(res);
      });
    } catch (e) {
      setLoginStatusCallback(false);

      if (getInfoConfigTokens) {
        getInfoConfigTokens(null);
      }
    }
  };

  (0, _react.useEffect)(function () {
    var interval;

    if (scriptLoaded) {
      if (window.aaWidget !== 'undefined') {
        initializeAAWidget(handleUserLoggedInAsync);

        if (doPolling) {
          interval = setInterval(function () {
            handleUserLoggedInAsync();
          }, 15000);
        }
      }
    }

    return function () {
      return doPolling ? clearInterval(interval) : null;
    };
  }, [scriptLoaded]);
  (0, _react.useEffect)(function () {
    dispatchEventHandler('uhfLoginChange', loginStatus);

    if (!reloadOnLogin) {
      if (loginStatus) {// getUserData();
      } else {
        resetLoginLabel();
      }
    }
  }, [loginStatus]);

  var elementReady = function elementReady(selector) {
    return new Promise(function (resolve) {
      var el = document.querySelector(selector);

      if (el) {
        resolve(el);
      }

      new MutationObserver(function (mutationRecords, observer) {
        Array.from(document.querySelectorAll(selector)).forEach(function (element) {
          resolve(element);
          observer.disconnect();
        });
      }).observe(document.documentElement, {
        childList: true,
        subtree: true
      });
    });
  };

  function elementExist() {
    return _elementExist.apply(this, arguments);
  }

  function _elementExist() {
    _elementExist = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee10() {
      var a, b;
      return _regenerator.default.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              a = elementReady('#aaw-login-tab');
              b = elementReady('#aaw-signup-tab');
              return _context10.abrupt("return", Promise.race([a, b]));

            case 3:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }));
    return _elementExist.apply(this, arguments);
  }

  var isUserNotloggedInAndLoginIconClicked = function isUserNotloggedInAndLoginIconClicked() {
    return loginclicked && !loginStatus;
  };

  var spinnerHideShowAfterCSSLoad = function spinnerHideShowAfterCSSLoad() {
    setShowSpinner(true);
    reloadWidget();
    elementExist().then(function () {
      setShowSpinner(false);
    });
  };

  (0, _react.useEffect)(function () {
    if (isUserNotloggedInAndLoginIconClicked()) {
      if (!styleLoaded) {
        createTags('link', 'href', "".concat(_constant2.ENV[environment].style), 'rel', 'stylesheet', spinnerHideShowAfterCSSLoad);
      } else {
        spinnerHideShowAfterCSSLoad();
      }
    }
  }, [loginclicked, loginStatus]);

  var MobileSSO = function MobileSSO() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(WidgetOverlay, {
      onClick: function onClick() {
        if (!isLoginMandated) {
          LoginModalClose();
          handleClick(false);
        }
      }
    }), /*#__PURE__*/_react.default.createElement(_BottomSheet.default, {
      height: deviceType === _constant2.DEVICE_TYPE.TABLET ? '35%' : undefined,
      zIndex: 99999
    }, showSpinner && /*#__PURE__*/_react.default.createElement(SpinnerWrapper, null, /*#__PURE__*/_react.default.createElement(_Spinner.default, null)), /*#__PURE__*/_react.default.createElement(SsoContainer, {
      handleClick: handleClick,
      showSpinner: showSpinner,
      isLoginMandated: isLoginMandated
    })));
  };

  var DesktopSSO = function DesktopSSO() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(WidgetOverlay, {
      onClick: function onClick() {
        if (!isLoginMandated) {
          LoginModalClose();
          handleClick(false);
        }
      }
    }), /*#__PURE__*/_react.default.createElement(SsoModalWrapper, {
      ref: ssoModalRef,
      onBlur: function onBlur(e) {
        return _utilities.default.trapFocus(e, ssoModalRef, null, document.getElementById('airasia-sso-modal-wrapper-close-button'));
      },
      onKeyDown: function onKeyDown(e) {
        return _utilities.default.keyDownHandler(e, function () {
          return !isLoginMandated && handleClick(false);
        }, _constant.KEY_CODE.ESC);
      }
    }, showSpinner && /*#__PURE__*/_react.default.createElement(_Spinner.default, null), /*#__PURE__*/_react.default.createElement(SsoContainer, {
      handleClick: handleClick,
      showSpinner: showSpinner,
      isLoginMandated: isLoginMandated
    })));
  };
  /**
   * After the User gets logged in , the inner HTML of aa_widget
   * where SSO is Painted is changed to something else of input type.
   * On Logout, That input tag is not updated because we are rendering
   * that component conditionally.
   *
    * So if User again tries to open the SSO, then the element for which the
   * mutation observer is waiting is not found because of some asynchronous activities.
   * Hence if page refreshes on logout , then that DOM
   * element is updated , if the someone doesn't want to page refresh then
   * there will be no conditional rendering rather the element will still be present
   * in the DOM from the begining of the page load
   *  and display proptery will be toggeled to none and block
   *
   */


  var getMain = function getMain() {
    if (isUserNotloggedInAndLoginIconClicked()) {
      return isMobile ? MobileSSO() : DesktopSSO();
    }

    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

var _default = SSOWidgetHandler;
exports.default = _default;